/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SolveBody
 */
export interface SolveBody {
    /**
     * The user's plaintext solution attempt
     * @type {string}
     * @memberof SolveBody
     */
    solution: string;
}

/**
 * Check if a given object implements the SolveBody interface.
 */
export function instanceOfSolveBody(value: object): value is SolveBody {
    if (!('solution' in value) || value['solution'] === undefined) return false;
    return true;
}

export function SolveBodyFromJSON(json: any): SolveBody {
    return SolveBodyFromJSONTyped(json, false);
}

export function SolveBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolveBody {
    if (json == null) {
        return json;
    }
    return {
        
        'solution': json['solution'],
    };
}

export function SolveBodyToJSON(json: any): SolveBody {
    return SolveBodyToJSONTyped(json, false);
}

export function SolveBodyToJSONTyped(value?: SolveBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'solution': value['solution'],
    };
}

